import styled from 'styled-components';

export const AccContentWrap = styled.div`
    margin-left: 45px;
    margin-right: 87px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-left: 20px;
        margin-right: 20px;
    }
`

export const ButtonWrap = styled.div`
    margin: 10px 0 0 -30px;
`

export const MarginBottom = styled.div`
    margin-bottom: ${props => props.marginBottom};
`

export const PercentageWrap = styled.div`
    /* display: flex; */
`

export const PercentageImageWrap = styled.img`
    margin-right: 10px;
`

export const InnerContentWrapper = styled.div`
    cursor: auto;
`

export const DisplayStyle = styled.div`
    display: inline-block;
`

export const PercentWrap = styled.div`
    margin-left: 28px;
`